import axios from "axios";

class BlogA3FirmaDigitalService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Alan Aguilar
   * @description Get the last post of A3FirmaDigital Blog
   * @date 26-07-2021
   * @param {String} token
   * @returns {Object}
   * @memberof BlogA3FirmaDigitalService
   */
  async getLastPostFromBlogA3FirmaDigital(token) {
    try {
      let response = await axios.get(
        `${this.apiUrl}/posts?categories=7&orderby=date&order=desc&per_page=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let image = await axios.get(
        response.data[0]._links["wp:featuredmedia"][0].href
      );
      response.data.image = image.data.media_details.sizes.medium.source_url;

      return response.data;
    } catch (err) {
      console.log("Error al obtener la informacion del post", err);
      return null;
    }
  }

  /**
   * @author Alan Aguilar
   * @description Format a date provided to 'NumberDay Month'
   * @date 26-07-2021
   * @param {Date} dateToFormat
   * @returns {Object}
   * @memberof BlogA3FirmaDigitalService
   */
  formatDateAndMonth = (dateToFormat) => {
    let dateProvided = new Date(dateToFormat);
    let day = dateProvided.getDate();
    let monthNumber = dateProvided.getMonth() + 1;

    let month = "";
    if (monthNumber === 1) {
      month = "ENE";
    } else if (monthNumber === 2) {
      month = "FEB";
    } else if (monthNumber === 3) {
      month = "MAR";
    } else if (monthNumber === 4) {
      month = "APR";
    } else if (monthNumber === 5) {
      month = "MAY";
    } else if (monthNumber === 6) {
      month = "JUN";
    } else if (monthNumber === 7) {
      month = "JUL";
    } else if (monthNumber === 8) {
      month = "AGO";
    } else if (monthNumber === 9) {
      month = "SEP";
    } else if (monthNumber === 10) {
      month = "OCT";
    } else if (monthNumber === 11) {
      month = "NOV";
    } else if (monthNumber === 12) {
      month = "DIC";
    }

    const dateParse = `${day} ${month}`;
    return dateParse;
  };
}

export { BlogA3FirmaDigitalService as default };
